import {
    carousel,
    map,
    planYourTripFormFullPage,
    onSiteSearch,
    search,
    optionGrid,
    signUpForm,
    requestYourInterest,
    autoComplete,
    dynamicFilter,
    cruiseDynamicFilter,
    placesToVisit,
    propertiesMap,
    paginatedContent,
    readMore,
    filter,
    filterPopup,
    tabSlider,
    searchFilter,
    scrollspy,
    itinerary,
    itineraryMap,
    roomCard,
    blogCard,
    listicleCard,
    itineraryCard,
    travelRestrictions,
    InterstitialPopup,
    destinationTruncation,
    retainScrollPosition,
    faq,
    preferenceCentre,
    tabs,
    scTrackOnClick,
    onLoadScrollTo,
    showMoreElements,
    loadContentOnClick,
    thirdPartyLinkNewTab
} from "./components";
import { Webtracking, LTGTracking } from "./utils/webtracking";
import Modal from "./components/modal/Modal";
import "./style.scss";
import Store from "./store/store";
import reducer from "./store/reducer";
import { initViewportListener } from "./utils";
import { GATracking } from "./utils/webtracking";
import toolTip from "./components/tooltip";
import CurrencySelector from "./components/currency-selector/CurrencySelector";
import Carousel from "./components/carousel/Carousel";
import { carouselOptions } from "./config";
import HashCheckToScroll from "./components/helper/hash-check-to-scroll";

const components = {
    carousel: carousel.init,
    map: map.init,
    searchFilter: searchFilter.init,
    optionGrid: optionGrid.init,
    dynamicFilter: dynamicFilter.init,
    placesToVisit: placesToVisit.init,
    PropertiesMap: propertiesMap.init,
    paginatedContent: paginatedContent.init,
    filter: filter.init,
    mobileFilter: filter.mobileInit,
    tabSlider: tabSlider.init,
    roomCard: roomCard.init,
    blogCard: blogCard.init,
    listicleCard: listicleCard.init,
    itineraryCard: itineraryCard.init,
    itineraryMap: itineraryMap.init,
    travelRestrictions: travelRestrictions.init,
    retainScrollPosition: retainScrollPosition.init,
    faq: faq.init,
    preferenceCentre: preferenceCentre.init,
    showMoreElements: showMoreElements.init,
    loadContentOnClick: loadContentOnClick.init,
    tabs: tabs.init,
    onLoadScrollTo: onLoadScrollTo.init,
    scTrackOnClick: scTrackOnClick.init,
};

function initialise() {
    var istablet = window.matchMedia('(max-width: 1024px)');
    const store = new Store(reducer);

    function checkForDelaconSessId() {
        return document.cookie.split(';').some(cookie => cookie.trim().startsWith('delaconsessid='));
    }

    function pollForDelaconCookie(interval, timeout) {
        const startTime = Date.now();
        const intervalId = setInterval(() => {
            if (checkForDelaconSessId()) {
                clearInterval(intervalId);
                // Initialize LTGTracking after webtracking has been initialized
                sd.utilities.webtracking.init();
            }
            if (Date.now() - startTime >= timeout) {
                clearInterval(intervalId);
                console.log("Timeout reached. 'delaconsessid' Cookie not detected.");
            }
        }, interval);
    }

    //global variables
    window.sd = {
        globals: {
            firstVisit: false
        },
        utilities: {
            webtracking: LTGTracking
        }
    }

    //initialize PYT full
    planYourTripFormFullPage.init();
    searchFilter.init();
    //initialize onsite search locally
    onSiteSearch.init();
    
    const searchButtons = document.querySelectorAll(".sd-search");
    search.init(searchButtons);
    
    signUpForm.init();
    requestYourInterest.init();

    const autocompleteInput = document.querySelector("#navbarSearch");
    autoComplete.init(autocompleteInput);

    const searchProperty = document.querySelector("#bannerSearch");
    autoComplete.init(searchProperty);

    const cruiseDynamicFilterSection = document.querySelector("#dynamicFilter");
    cruiseDynamicFilter.init(cruiseDynamicFilterSection);
    
    readMore.init();
    toolTip.init();

    const onsiteFilter = document.querySelector(".on-site-filter");
    filterPopup.init(onsiteFilter);

    //initialise truncation component
    destinationTruncation.init();

    //initialize webtracking  
    Webtracking.init(window.sd);

    InterstitialPopup.init();
    scrollspy.init();
    itinerary.init();
    thirdPartyLinkNewTab.init();

    pollForDelaconCookie(500,300000); // Poll every 0.5s for delaconSessId - timeout now set to 5 min instead of previously 5s

    // media query listener
    initViewportListener(store);

    // Initialise required components
    if (window.UV && window.UV.components) {
        window.UV.components.forEach((name) => {
            const init = components[name];
            if (init) {
                init(store);
            }
        });
    }

    function initCurrencySelector(containerId, selectCurrency) {
        const CurrencyContainer = document.getElementById(containerId);
        if (CurrencyContainer) {
            const currencyList = document.querySelectorAll(selectCurrency);
            new CurrencySelector(CurrencyContainer, currencyList);
        }
    }
    initCurrencySelector("currency__selector", ".currency__selector li");
    
    function initModal(containerId, openButtonsSelector) {
        const modalContainer = document.getElementById(containerId);
        if (modalContainer) {
            const modalContent = modalContainer.querySelector(".sd-modal__content");
            const openModalButtons = document.querySelectorAll(openButtonsSelector);

            if (modalContent && openModalButtons) {
                new Modal(modalContainer, openModalButtons);
            }
        }
    }
    initModal("deck-plan-container", ".deck-plan__button");
    initModal("view-photos-container", ".view__photos");

    const viewPhotosContainer = document.querySelector("#view-photos-container");
    const photoGallery = document.querySelectorAll(".view__photo");
    const modalGalleryContainer = document.querySelector("#view-photos-inner");
    const modalGalleryCarousel = new Carousel(modalGalleryContainer, store, carouselOptions['#view-photos-inner'] || {});

    if (photoGallery) {
        [...photoGallery].forEach((photo, index) => {
            initModal("view-photos-container", ".view__photo");
            photo.addEventListener("click", () => {
                const tabs = viewPhotosContainer.querySelectorAll('input[type="radio"]');
                tabs.forEach(tab => {
                    tab.getAttribute("id") === "images" ? tab.checked = true : tab.checked = false
                });

                if (modalGalleryCarousel) {
                    modalGalleryCarousel.setSlide(index);
                }
            })
        })
    }

    // main menu script
    const dropdownMenuItems = document.querySelectorAll(".sd-navigation-expand__dropdown");
    const menuBackDrop = '<div class="sd-menuBackDrop" aria-hidden="true" data-acsb-hidden="true"></div>';
    document.body.insertAdjacentHTML("afterbegin", menuBackDrop);
    const closeBackDrop = document.querySelector(".sd-menuBackDrop");

    dropdownMenuItems.forEach(menuItem => {
        menuItem.addEventListener("click", (event) => {
            closeBackDrop.style.display = "block";
            if (!menuItem.classList.contains("active")) {
                dropdownMenuItems.forEach(el => el.classList.remove("active"))
                menuItem.classList.add("active");
            } else if (event.target.parentElement.classList.contains("sd-navigation-expand__dropdown")) {
                menuItem.classList.toggle("active");
                if (closeBackDrop.style.display === "none") {
                    closeBackDrop.style.display = "block";
                } else {
                    closeBackDrop.style.display = "none";
                }
            }
        })
    })
    //second level for mobile only
    const dropdownSubMenuItems = document.querySelectorAll(".sd-navigation-expand-content__dropdown");
    function setSubNav() {
        if (istablet.matches) {
            dropdownSubMenuItems.forEach(submenuItem => {
                submenuItem.addEventListener("click", (event) => {

                    if (!submenuItem.classList.contains("active-sub")) {
                        dropdownSubMenuItems.forEach(el => el.classList.remove("active-sub"))
                        submenuItem.classList.add("active-sub");

                    } else if (event.target.parentElement.classList.contains("sd-navigation-expand-content__dropdown")) {
                        submenuItem.classList.toggle("active-sub");
                    }
                })
            })
        }
    }
    setSubNav();

    //back button mobile nav menu
    function collectionHas(a, b) { //helper function 
        for (var i = 0, len = a.length; i < len; i++) {
            if (a[i] == b) return true;
        }
        return false;
    }
    function findParentBySelector(elm, selector) {
        var all = document.querySelectorAll(selector);
        var cur = elm.parentNode;
        while (cur && !collectionHas(all, cur)) { //keep going up until you find a match
            cur = cur.parentNode; //go up
        }
        return cur; //will return null if not found
    }

    var backTwo = document.querySelectorAll(".levelTwo");
    var selector = (".sd-navigation-expand-content__dropdown");

    backTwo.forEach(backItm => {

        var parent = findParentBySelector(backItm, selector);
        backItm.addEventListener("click", (event) => {

            setTimeout(function () {
                parent.classList.remove("active-sub");
            }, 150)

        })
    })

    // secondary navigation scroll to div with animation
    let header = document.querySelector(".global__header");
    let navigation = document.querySelector(".global__navigation-bar");
    let navigationHeight = null;
    if (navigation) {
        navigationHeight = navigation.clientHeight;
    }
    let headerHeight = null;
    if (header) {
        headerHeight = header.clientHeight;
    }
    let headerOffset = null;
    if (navigationHeight && headerHeight) {
        headerOffset = navigationHeight + headerHeight;
    }

    function scrollToLink(e) {
        e.preventDefault();
        let hash = this.getAttribute('href');
        let target = document.querySelector(hash);

        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    document.querySelectorAll('.sd-page-navigation__item a[href^="#"]').forEach(trigger => {

        let hash = trigger.getAttribute('href');
        let target = document.querySelector(hash);

        if (target === null) {
            trigger.remove();
            return;
        }
        trigger.addEventListener('click', scrollToLink);
    });

    function setnavScroll() {
        const secondaryNavigationItems = document.querySelectorAll(".sd-navigation-expand ul li");
        const mainNav = document.getElementById('mobile-expand');
        let isSubCategoryOpen;
        let isSubMenuOpen;
        secondaryNavigationItems.forEach(navItem => {
            navItem.addEventListener("click", (event) => {
                setTimeout(function () {
                    isSubMenuOpen =  document.querySelector('.sd-navigation-expand__item.active');
                    isSubCategoryOpen = document.querySelector('.active-sub');
                    if(isSubMenuOpen && !isSubCategoryOpen){
                        mainNav.classList.add('sub-menu-open');
                        mainNav.classList.remove('sub-category-open');
                        let scrolltotop = document.querySelector(".sd-navigation-expand");
                        scrolltotop.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                    }
                    else if(isSubCategoryOpen && isSubMenuOpen){
                        let subMenuOpenContent = isSubMenuOpen.querySelector('.sd-navigation-expand-content');
                        subMenuOpenContent.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                        mainNav.classList.remove('sub-menu-open');
                        mainNav.classList.add('sub-category-open');
                    }
                    else{
                        mainNav.classList.remove('sub-menu-open','sub-category-open');
                    }
                }, 200);

            })
        });
    }
    if (istablet.matches) {
        setnavScroll();
    }

    //#region history state scroll position
    //store Scroll position before the page is left to ensure the most recent position is captured
    window.addEventListener("pagehide", (event) => {
        var scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        history.replaceState({ scrollPosition, path: history.state.path ? history.state.path : null }, "", document.location.pathname); //uses replaceState to adapt the current pages state as opposed to creating a new one (causes double entries which is unpleasent when navigating with back/forward arrows)
    });

    //when page loads (after the dom content is loaded) check history state for any scroll positions and if there is an existing one then scroll to that position
    window.addEventListener("pageshow", () => {
        var pageState = history.state;
        if (pageState) {
            var path = pageState.path;
            var searchQuery = pageState.searchQuery;
            if (pageState && pageState.scrollPosition) {
                window.scrollTo({
                    left: 0,
                    top: parseInt(pageState.scrollPosition),
                    behavior: "instant",
                });
            }
            if (pageState && pageState.path) {
                history.replaceState({ scrollPosition: pageState.scrollPosition, path }, "", pageState.path);
            }
            if (pageState && pageState.searchQuery) {
                history.replaceState({ scrollPosition: pageState.scrollPosition, searchQuery }, "", document.location.pathname);
            }
        }
    });

    //#endregion

    if (closeBackDrop) {
        closeBackDrop.addEventListener("click", () => {
            closeBackDrop.style.display = "none";
            dropdownMenuItems.forEach(el => el.classList.remove("active"))
        })
    }

    const offsetEle = document.querySelector(".home__banner__content");
    if (offsetEle) {
        const offsetTop = document.querySelector(".home__banner__content").offsetHeight;
        const searchicon = document.querySelector(".sd-header-drawer > .sd-search");
        window.onscroll = () => {
            searchicon.style.display = "none";
            if (window.scrollY > offsetTop) {
                searchicon.style.display = "flex"
            }
        }
    }

    const navbarToggler = document.querySelector("#sd-navigation-drawer__open-handle");
    const mainMenu = document.querySelector(".sd-navigation-expand");
    if (mainMenu) {
        const menuCheckboxLists = mainMenu.querySelectorAll('input[type="checkbox"]');
        if (navbarToggler) {
            navbarToggler.addEventListener("click", () => {
                if (navbarToggler.checked === false) {
                    menuCheckboxLists.forEach(checkbox => {
                        if (checkbox.checked == true) {
                            checkbox.checked = false;
                        }
                    })
                }
                const root = document.getElementsByTagName('html')[0];

                if (navbarToggler.checked === true) {
                    root.classList.add('mobile-menu-active');
                    mainMenu.classList.add('displayMobile');

                    const scrolltotop = document.querySelector(".sd-navigation-expand");
                    setTimeout(function () {
                        scrolltotop.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                    }, 150);
                }
                else if (navbarToggler.checked === false) {
                    root.classList.remove('mobile-menu-active');
                    mainMenu.classList.remove('displayMobile');
                    mainMenu.classList.remove('sub-category-open');
                    mainMenu.classList.remove('sub-menu-open');
                    dropdownMenuItems.forEach(el => el.classList.remove("active"));
                    dropdownSubMenuItems.forEach(el => el.classList.remove("active-sub"));
                }
            })
        }
    }

    // script for country and currency list
    const countryBox = document.querySelector(".sd-toolbar__country-box");
    const toolBar = document.querySelector(".sd-toolbar");

    let countryCheckbox = null;
    if (countryBox) {
        countryCheckbox = countryBox.querySelector("input[type='checkbox']");
    }

    const currencyBox = document.querySelector(".sd-toolbar__currency-box");
    let currencyCheckbox = null;
    if (currencyBox) {
        currencyCheckbox = currencyBox.querySelector("input[type='checkbox']");
    }
    document.body.addEventListener("click", (event) => {
        if (event.target.id === "selected__country") {
            currencyCheckbox.checked = false;
            closeBackDrop.style.display = "block";
        } else if (event.target.id === "selected__currency") {
            countryCheckbox.checked = false;
            closeBackDrop.style.display = "block";
            toolBar.classList.add("zindex");
        } else if (event.target === closeBackDrop) {
            currencyCheckbox.checked = false;
            countryCheckbox.checked = false;
            closeBackDrop.style.display = "none";
        }
    });

    const observer = lozad();
    observer.observe();

    window.onload = () => {
        let currentPage = 1;

        this.queryParams = new URLSearchParams(window.location.search);
        if (this.queryParams) {
            this.queryParamsValue = Object.fromEntries(this.queryParams.entries());
        }
        if (window.location.href.includes("scott-dunn-private/people") || window.location.href.includes("scott-dunn-private/benefits")) {
            document.getElementsByClassName("benefits__cards")[1].classList.add("sdp-inspiration");
        }
        if (window.location.href.includes("scott-dunn-private/places-to-stay/hotels") || window.location.href.includes("scott-dunn-private/places-to-stay")) {
            document.getElementsByClassName("benefits__cards")[0].classList.add("sdp-inspiration");
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'page_data',
            'page_type': UV.page.type,
            'destination': UV.page.location,
            'destination_region': '',
        });
        this.originalText = document.getElementsByClassName("sd-h3")[0].innerHTML;
        if (window.location.href.indexOf("page=") > -1) {
            if (document.getElementsByClassName("sd-read-more-content")[0]) {
                document.getElementsByClassName("sd-read-more-content")[0].style.display = "none";
            }
            document.getElementsByClassName("sd-global__content")[0].style.display = "none";
            if (window.innerWidth > 768)
                document.getElementsByClassName("on-site-filter")[0].style.marginTop = '50px';
            if (this.queryParamsValue["page"]) {
                currentPage = this.queryParamsValue["page"];
                document.getElementsByClassName("sd-h3")[0].innerHTML = this.originalText + " - Page " + currentPage;
            } else {
                document.getElementsByClassName("sd-h3")[0].innerHTML = this.originalText + " - " + this.capitalize((window.location.href.split('page')[1]).replace(/[=]/g, "Page "));
            }
        } else {
            if (document.getElementsByClassName("sd-read-more-content")[0])
                document.getElementsByClassName("sd-read-more-content")[0].style.display = "block";
            if (document.getElementsByClassName("sd-global__content")[0])
                document.getElementsByClassName("sd-global__content")[0].style.display = "block";
            if (document.getElementsByClassName("on-site-filter")[0])
                document.getElementsByClassName("on-site-filter")[0].style.marginTop = '45px';
            if (document.getElementsByClassName("sd-h3")[0])
                document.getElementsByClassName("sd-h3")[0].innerHTML = this.originalText;
        }
    }
    function capitalize(s) { return s[0].toUpperCase() + s.slice(1); }

    // Promotions
    const GATagsPromotion = document.querySelectorAll('[data-ga="promotion"]');
    [...GATagsPromotion].forEach((GATag, index) => {
        GATag.querySelectorAll('[data-ga-click="promotion"]').forEach(promotion => {
            promotion.addEventListener("click", () => {
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    'event': 'promotionClick',
                    'ecommerce': {
                        'promoClick': {
                            'promotions': [{
                                'id': GATag.getAttribute('data-ga-promoid'),
                                'name': GATag.getAttribute('data-ga-promoname'),
                                'creative': UV.page.type + '_promo_banner',
                                'position': GATag.getAttribute('data-ga-index') ?? index + 1
                            }]
                        }
                    },
                    'eventCallback': function () {
                        document.location = promoObj.destinationUrl;
                    }
                });
            });
        })
    });

    const GATags = document.querySelectorAll('[data-ga]');
    [...GATags].forEach(GATag => {
        // phoneNumber
        if (GATag.getAttribute('data-ga') === "navbarContact") {
            GATag.addEventListener("click", () => {
                GATracking.eventTracking('header_click', 'header', 'navigation', GATag.innerText);
            })
        }
        // My ScottDunn
        if (GATag.getAttribute('data-ga') === "myScottDunn") {
            GATag.addEventListener("click", () => {
                GATracking.eventTracking('footer', 'footer', 'navigation', GATag.innerText);
            })
        }
        // Top Destination
        if (GATag.getAttribute('data-ga') === "topDestinations") {
            GATag.addEventListener("click", () => {
                GATracking.eventTracking('homepage_click', 'homepage', 'top destinations', GATag.innerText);
            });
        }
        // Carousel
        if (GATag.getAttribute('data-ga') === "carousel") {
            const componentTitle = GATag.getAttribute('data-ga-componentname');
            GATag.querySelectorAll('[data-ga-componenttitle]').forEach(link => {
                link.addEventListener("click", () => {
                    GATracking.eventTracking('carousel_click', 'carousel', link.getAttribute('data-ga-componenttitle'), componentTitle);
                })
            })
        }
        // Footer
        if (GATag.getAttribute('data-ga') === "footer") {
            GATag.addEventListener("click", () => {
                GATracking.eventTracking('footer_click', 'footer', 'navigation', GATag.innerText);
            });
        }
        // Social
        if (GATag.getAttribute('data-ga') === "social") {
            GATag.addEventListener("click", () => {
                GATracking.eventTracking('footer_click', 'footer', 'navigation', GATag.getAttribute('aria-label'));
            });
        }
        // hub pages
        if (GATag.getAttribute('data-ga') === "hubPages") {
            GATag.addEventListener("click", () => {
                GATracking.eventTracking('hub_click', 'hub page', GATag.getAttribute('data-ga-action'), GATag.getAttribute('data-ga-hubtitle'));
            });
        }
        // price guide
        if (GATag.getAttribute('data-ga') === "product") {
            GATag.addEventListener("click", () => {
                window.dataLayer.push({
                    'event': 'product_click',
                    'event_category': 'product page',
                    'event_action': 'cta',
                    'event_label': 'epic round the world ski tour',
                    'departing': GATag.getAttribute('data-ga-departing'),
                    'starting_price': GATag.getAttribute('data-ga-pricefrom'),
                    'starting_deposit': GATag.getAttribute('data-ga-depositefrom')
                })
            })
        }
        //sub navigation click events
        if (GATag.getAttribute('data-ga') === "sub navigation") {
            GATag.addEventListener("click", (e) => {
                GATracking.eventTracking(
                    GATag.getAttribute('data-ga-event'),
                    GATag.getAttribute('data-ga-category'),
                    GATag.getAttribute('data-ga-action'),
                    GATag.getAttribute('data-ga-label') == null || GATag.getAttribute('data-ga-label') === 'undefined' ? e.target.innerText : GATag.getAttribute('data-label'));
            });
        }

    })

    const GATagsCategories = document.querySelectorAll('[data-ga-category]');
    const GATagsPageTitles = document.querySelectorAll('[data-ga-pagetitle]');
    let GATagsPageTitlesVal = null;
    [...GATagsCategories].forEach(GATagsCategorie => {
        GATagsCategorie.addEventListener("click", () => GATagsPageTitlesVal = GATagsCategorie.getAttribute('data-ga-category'))
    });

    [...GATagsPageTitles].forEach(GATagsPageTitle => {
        GATagsPageTitle.addEventListener("click", () => {
            let GATagsSubCategory = GATagsPageTitle.getAttribute('data-ga-subCategory');
            if (GATagsPageTitlesVal) {
                const eventLabel = GATagsPageTitlesVal + " - " + GATagsSubCategory + " - " + GATagsPageTitle.getAttribute('data-ga-pagetitle');
                GATracking.eventTracking('header_click', 'header', 'navigation', eventLabel);
            }
        })
    })


    //climate guide
    if (document.querySelectorAll('.sd-climate-container').length) {
        const climateGuide = document.querySelector(".sd-climate-container");
        const climateTable = climateGuide.querySelectorAll(".option-grid-chart");
        var a = window.matchMedia("(min-width: 768px)");

        var select = document.getElementById("option-grid");
        climateTable.forEach((div) => {
            var values = [];
            var id = div.id;
            values.push(id);

            function bindOption() {
                for (var i = 0; i < values.length; i++) {
                    var optn = values[i];
                    var el = document.createElement("option");

                    el.textContent = optn;
                    el.value = optn;
                    select.appendChild(el);
                }
            }
            bindOption();

        });

        const hideGuides = document.querySelectorAll(".option-grid-chart");
        for (var i = 0; i < hideGuides.length; i++) {
            hideGuides[0].style.display = 'flex';
        }
        var e = document.querySelector(".sd-option-list__select");
        var value = e.value;
        var text = e.options[e.selectedIndex].text;
        var hrefOne = document.getElementById(text);
        var firstHref = hrefOne.getAttribute('data-url');

        document.getElementById('city-name').innerHTML = "<a href=" + firstHref + ">" + value + "</a>";

        select.addEventListener('change', function (e) {

            const hideGuides = document.querySelectorAll(".option-grid-chart");
            for (var i = 0; i < hideGuides.length; i++) {
                hideGuides[i].style.display = 'none';
            }
            var node = e.target.value;

            // console.log(node1);
            var optionSelected = document.getElementById(node);
            var cityName = document.getElementById('city-name');
            var anchorUrl = optionSelected.getAttribute('data-url');
            var cityUrl = "<a href=" + anchorUrl + ">" + node + "</a>";
            optionSelected.style.display = "flex";

            cityName.innerHTML = cityUrl;
        });
    }
    //prevent naviagtion to url top menu
    const topLinkClick = document.querySelectorAll(".sd-navigation-expand__item.sd-navigation-expand__dropdown > a");
    topLinkClick.forEach(hrefClick => {
        hrefClick.addEventListener("click", (event) => {
            event.preventDefault();
        })

    })
    //prevent naviagtion to url second level menu
    const secondLevelClick = document.querySelectorAll(".sd-navigation-expand-content__dropdown > .sd-body2");
    secondLevelClick.forEach(anchorClick => {
        anchorClick.addEventListener("click", (event) => {
            if (istablet.matches) {
                event.preventDefault();
            }
        })
    })
    //currency nav in mobile
    function createCurrencyList() {

        let clone = document.querySelector('.sd-toolbar__currency-box ul.sd-body2').cloneNode(true);

        clone.setAttribute('class', 'sd-navigation-expand-content__item-list');
        document.getElementById('currencyMenuMobile').appendChild(clone);

    }
    createCurrencyList()

    //search results blank when country changed
    function reloadWithqstr() {
        if (window.location.href.indexOf("search-list") > -1) {
            const str = location.search;
            if (str) {
                // console.log(str);
                const countryLinks = document.querySelectorAll(".sd-toolbar__country-box .sd-body2 li > a");
                countryLinks.forEach(link => {
                    var linkHref = link.href;
                    link.href = linkHref + str;
                })
            }
        }
    }

    reloadWithqstr()

    const onFilter = document.querySelector(".on-site-filter")
    if (onFilter) {
        document.addEventListener('click', function (e) {
            var container = document.querySelector('.on-site-filter');
            var target = document.querySelector('.sd-filter-by-form');
            var addActive = document.querySelectorAll('.sd-filter-dd');

            if (!container.contains(e.target)) {
                if (target!==null) {
                    target.style.display = 'none';
                }
                    
                addActive.forEach(div => {
                    div.classList.remove("active");
                })
            }
        });
    }

    if (performance.getEntriesByType("navigation")[0].type === 'back_forward') {
        setTimeout(() => {
            window.location.reload()
        }, 300)
    }
}
document.addEventListener("DOMContentLoaded", initialise);

setTimeout(function () {

    var errorDiv = document.getElementById("errorMessage");
    var canonicalUrl = document.querySelector('link[rel="canonical"]');
    if (errorDiv) {

        var metaRobots = document.querySelector('meta[name="robots"]');

        // if there was no robots meta tag, add one
        if (!metaRobots) {
            metaRobots = document.createElement('meta');
            metaRobots.setAttribute('name', 'robots');
            document.head.appendChild(metaRobots);
        }
        // tell Google to exclude this page from the index
        metaRobots.setAttribute('content', 'nofollow, noindex');
        canonicalUrl.remove();
    }
}, 1000)
